import PlusIcon from '@heroicons/react/24/solid/PlusIcon';
import {
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import {
  useFetcDocumentsType,
  useRemoveDocumentType,
} from '@/shared/actions/erp';
import { CustomSearch, GeneralTable } from '@/shared/components/ui';
import { useTableFilter } from '@/shared/hooks';
import { ITipoDocumento } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';

export type DocumentsTypePageProps = {};

const columns: any = [
  {
    accessorKey: 'id_tipo_documento',
    header: 'ID',
    size: 75,
  },
  {
    accessorKey: 'nombre',
    header: 'Nombre',
    size: 200,
  },
];

const DocumentsTypePage: React.FC<DocumentsTypePageProps> = () => {
  const navigate = useNavigate();

  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);

  ///* mutations
  const deleteDocumentTypeMutation = useRemoveDocumentType();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: tiposDocumento,
    isLoading,
    isRefetching,
  } = useFetcDocumentsType(pageIndex + 1, searchTerm);

  ///* handlers
  const onDelete = async (original: ITipoDocumento) => {
    setConfirmDialog({
      isOpen: true,
      subtitle: '¿Está seguro que desea eliminar el documento seleccionado?',
      title: 'Confirmar',
      onConfirm: async () => {
        deleteDocumentTypeMutation.mutate(original.id_tipo_documento);
      },
      onClose() {
        setConfirmDialogIsOpen(false);
      },
    });
  };

  const onEdit = (original: ITipoDocumento) => {
    navigate(
      `/configuracion/tipos-documentos/editar/${original.id_tipo_documento}`
    );
  };

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Stack spacing={1} pb={5}>
              <Typography variant="h4">Tipos de Documentos</Typography>
            </Stack>
            <div>
              <Button
                startIcon={
                  <SvgIcon fontSize="small">
                    <PlusIcon />
                  </SvgIcon>
                }
                variant="contained"
                onClick={() =>
                  navigate('/configuracion/tipos-documentos/crear')
                }
              >
                Crear
              </Button>
            </div>
          </Stack>

          <CustomSearch
            onChange={onChangeFilter}
            value={globalFilter}
            text="tipo de documento"
          />

          <GeneralTable<ITipoDocumento>
            columns={columns}
            data={tiposDocumento?.data?.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={tiposDocumento?.data?.count}
            // // actions
            positionActionsColumn="first"
            actionsColumnSize={20}
            // crud
            onEdit={onEdit}
            canDelete
            onDelete={onDelete}
          />
        </Stack>
      </Container>
    </Box>
  );
};

export default DocumentsTypePage;
